import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  constructor(private router:Router) { }
  about(){
    this.router.navigate(['/about']);
  }
  ngOnInit(): void {
  }

  goToExpert(){
    console.log('click');
    this.router.navigateByUrl('/dashboard#expert');
 }
 goToCalc(){
  console.log('click');
  this.router.navigate(['../../dashboard'], { fragment: 'calculator' } );
}

goToTest(){
  console.log('click');
  this.router.navigate(['/dashboard'], { fragment: 'Testing' } );
}

}
